import React from 'react';
import { FridgeProvider } from './useFridgeContext';
import { ShoppingCartProvider } from './useShoppingCartContext';

const providers = [
  FridgeProvider,
  ShoppingCartProvider,
];

const ContextProviders = ({ children }) => providers.reduceRight((nestedProvider, Parent) => (
  <Parent>{nestedProvider}</Parent>
), children);

const withContextProviders = (Component) => (props) => (
  <ContextProviders>
    <Component {...props} />
  </ContextProviders>
);

export default withContextProviders;
